import { render } from "./AddFeedback.vue?vue&type=template&id=1b229c30"
import script from "./AddFeedback.vue?vue&type=script&lang=js"
export * from "./AddFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__